"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFileDescriptor = void 0;
/**
 * @param {Image} image
 * @param {FileDescriptor} fileDescriptor
 * @returns Image
 */
function parseFileDescriptor(image, fileDescriptor) {
    var type = fileDescriptor.mimeType.split('/')[0].toLowerCase();
    if (type !== 'image') {
        throw new Error('file is not an image');
    }
    image.path = fileDescriptor.path;
    image.fileName = image.path.split('/').pop();
}
exports.parseFileDescriptor = parseFileDescriptor;
//# sourceMappingURL=file-descriptor-parser.js.map